
import { Trash2, Lock, RefreshCw, LockOpen, UserCheck, UserLock} from"lucide-react"

import {controllerConectaPro} from "../../../../services/controllers/service-activation";
import {useConectaPro} from "../../../../store/service-activation/useConectaPro";

import { Action } from "../../../../components/ui/Action";
import {copyToClipboard, formatCellPhoneNumber, formatName, formatSMSCode} from "../../../../services/functions";

export function User({ userKey }){
  const CLConectaPro = controllerConectaPro()

  const user = useConectaPro(st=>st.data.users[userKey])

  const lockUserName = `block-conecta-pro-user:${userKey}`
  const removeUserName = `remove-conecta-pro-user:${userKey}`
  const refreshSecurityCode = `refesh-conecta-pro-security-code:${userKey}`

  const lockIcon = user.active ? LockOpen : Lock;
  const lockTitle = user.active ? "Bloquear número" : "Desbloquear número";

  return(
      <div data-active={user.active} className="group/user flex items-center gap-4 py-2 px-4 rounded hover:bg-zinc-50">
        {user.active && <UserCheck className="w-7 h-7 text-green-600" />}
        {!user.active && <UserLock className="w-7 h-7 text-zinc-800 opacity-40 transition-opacity duration-300 group-hover/user:!opacity-100"/>}
        <span className="flex-1 flex w-full transition-opacity duration-300 group-data-[active='false']/user:opacity-40 group-hover/user:!opacity-100">{formatName(user.name)}</span>
        <span
          className="flex px-4 w-40 justify-end transition-opacity duration-300 group-data-[active='false']/user:opacity-40 group-hover/user:!opacity-100"
          onCopy={(e) => copyToClipboard(user.code, e)}
        >
          {formatSMSCode(user.code) || '000-000' }
        </span>
        <span
          className="flex px-4 w-40 justify-end transition-opacity duration-300 group-data-[active='false']/user:opacity-40 group-hover/user:!opacity-100">{formatCellPhoneNumber(user.cellphone)}</span>
        <Action.Root
          outline
          status="500"
          type="button"
          title="Gerar novo código"
          name={refreshSecurityCode}
          onClick={() => CLConectaPro.refreshSecurityCode(userKey)}
        >
          <Action.Icon icon={RefreshCw} size={18} strokeWidth={3} />
        </Action.Root>
        <Action.Root
          status="warning"
          type="button"
          title={lockTitle}
          name={lockUserName}
          onClick={() => CLConectaPro.setUserStatus(userKey, !user.active)}
        >
          <Action.Icon icon={lockIcon} size={18} strokeWidth={3}/>
        </Action.Root>
        <Action.Root
          status="danger"
          type="button"
          title="Remover número"
          name={removeUserName}
          onClick={() => CLConectaPro.removeUser(userKey)}
        >
          <Action.Icon icon={Trash2} size={18} strokeWidth={3}/>
        </Action.Root>
      </div>
  )
}
